import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { pdfDocEncodingDecode, PDFDocument } from 'pdf-lib';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import pdfWorker from 'pdfjs-dist/build/pdf.worker.entry';

// Set worker for pdf.js
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const Newcheck = () => {
    const [file, setFile] = useState(null);
    const [newFileName, setNewFileName] = useState('');
    const [pageNumbers, setPageNumbers] = useState(1);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [newpdf, setnewpdf] = useState(null);
    const [selectedName, setSelectedName] = useState('');
    const [newselectedName, setnewSelectedName] = useState('');
    const[newblob,setnewblob]=useState(null);
    const[employeecode,setemployeecode]=useState('');
    const[namess,setnames]=useState('');
    const [loading,setLoading] = useState(false);
    const[disable,setdisable]=useState(false);
    const [pdfInfo, setPdfInfo] = useState([]);
    

    let pdfBlob;

    const names = ['Bio-Data', 'Appointment', 'Personal Files', 'ESI & PF', 'Certificates', 'ID Proofs'];

    // useEffect(() => {
    //     if (newpdf) {
    //         const iframe = document.getElementById('pdf-iframe');
    //         if (iframe) {
    //             iframe.src = `${newpdf}#page=1&zoom=fit`; // Always set to page 1
    //         }
    //     }
    // }, [newpdf]);

    // useEffect(() => {
    //     if (pdfUrl) {
    //         const iframe = document.getElementById('pdf-iframes');
    //         if (iframe) {
    //             iframe.src = `${newpdf}#page=1&zoom=fit`; // Always set to page 1
    //         }
    //     }
    // }, [pdfUrl]);

    const handleRefresh = () => {
        window.location.reload();
      };


    const base64ToBlob = (base64, contentType) => {
        const byteCharacters = atob(base64);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
          const slice = byteCharacters.slice(offset, offset + 512);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
      
        return new Blob(byteArrays, { type: contentType });
      };
      
      const sendFilesToBackend = async (e) => {
         e.preventDefault();
    
       
        const formData = new FormData();
        // formData.append('employeeId', employeecode);
        // append('UploadFiles', pdfBlob, `${newFileName}.pdf`);
        formData.append('bucketName', 'one-erp-beta');
        formData.append('storageMethod', 'S3');
        formData.append('subFolderName', 'EmployeeDocument');
       
        names.forEach((name) => {
            const storedData = pdfData[name]; 
    
            if (storedData) {
                const employeeId = employeecode;
                const blob = base64ToBlob(storedData, 'application/pdf'); 
               
                formData.append('UploadFiles', blob, `${employeeId}_${name}.pdf`);
              
            } else {
                console.log(`No data found for: ${name}`);
            }
        });
    
        try {
           
            const response = await axios.post('http://localhost:8081/api/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Important for file uploads
                },
            });

            // https://service.khexports.in/api/common/saveAttachment
    
            console.log('Successfully uploaded all files:', response.data);
            alert(response.data)
        } catch (error) {
            console.error('Error uploading files:', error.response ? error.response.data : error.message);
        }
    
        setPdfData({}); 
    };


    // const sendFilesToBackend = async (e) => {
    //     e.preventDefault();
    
    //     // Create a new FormData object
    //     const formData = new FormData();
    //     formData.append('employeeId', employeecode);
    //     // append('UploadFiles', pdfBlob, `${newFileName}.pdf`);
    //     formData.append('bucketName', 'one-erp-beta');
    //     formData.append('storageMethod', 's3');
    //     formData.append('subFolderName', 'EmployeeDocument');
    //     // Loop through each name in the `names` array
    //     names.forEach((name) => {
    //         const storedData = pdfData[name]; // Get base64 string from state
    
    //         if (storedData) {
    //             const employeeId = employeecode; // Assuming employeecode is the employee ID
    //             const blob = base64ToBlob(storedData, 'application/pdf'); // Convert base64 to Blob
                
               
    //             // Append the file to FormData with the specified naming convention
    //             formData.append('UploadFiles', blob, `${employeeId}_${name}.pdf`);
    //              // Change 'file' to 'files' for multiple files
    //         } else {
    //             console.log(`No data found for: ${name}`);
    //         }
    //     });
    
    //     try {
    //         // Send POST request to your backend using Axios
    //         const response = await axios.post('https://servicestest.khexports.in/api/', formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data', // Important for file uploads
    //             },
    //         });
    
    //         console.log('Successfully uploaded all files:', response.data);
    //     } catch (error) {
    //         console.error('Error uploading files:', error.response ? error.response.data : error.message);
    //     }
    
    //     setPdfData({}); // Reset pdfData if needed
    // };
    

    // const downloadFiles = (e) => {
    //     // e.preventDefault();
        
    //     // Iterate over each name in the `names` array
    //     names.forEach((name) => {
    //         const storedData = pdfData[name]; // Get base64 string from state instead of localStorage
    
    //         if (storedData) {
    //             const blob = base64ToBlob(storedData, 'application/pdf'); // Convert base64 to Blob
    //             const url = window.URL.createObjectURL(blob); // Create URL from Blob
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute('downloa+d', `${employeecode}_${name}.pdf`); // Download as PDF
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link); // Cleanup
    //             window.URL.revokeObjectURL(url); // Free memory
    //         } else {
    //             console.log(`No data found for: ${name}`);
    //         }
    //     });
    //     setPdfData({});
    // };

    const downloadFiles = (e) => {
        // e.preventDefault();
    
        // Iterate over each key in the `pdfData` object (all the files in `pdfData`)
        Object.keys(pdfData).forEach((name) => {
            const storedData = pdfData[name]; // Get base64 string from state instead of localStorage
    
            if (storedData) {
                const blob = base64ToBlob(storedData, 'application/pdf'); // Convert base64 to Blob
                const url = window.URL.createObjectURL(blob); // Create URL from Blob
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${name}.pdf`); // Download as PDF  ${employeecode}_
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); // Cleanup
                window.URL.revokeObjectURL(url); // Free memory
            } else {
                console.log(`No data found for: ${name}`);
            }
        });
    
        setPdfData({}); // Clear the pdfData after downloading all files
    };
    
    
      const mergePdfs = async (existingBlobString, newBlob) => {
        const existingPdfBytes = await existingBlobString.arrayBuffer();
        const newPdfBytes = await newBlob.arrayBuffer();
    
        const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
        const newPdfDoc = await PDFDocument.load(newPdfBytes);
    
        const mergedPdfDoc = await PDFDocument.create();
    
        // Add pages from the existing PDF
        const existingPages = await mergedPdfDoc.copyPages(existingPdfDoc, existingPdfDoc.getPageIndices());
        existingPages.forEach((page) => mergedPdfDoc.addPage(page));
    
        // Add pages from the new PDF
        const newPages = await mergedPdfDoc.copyPages(newPdfDoc, newPdfDoc.getPageIndices());
        newPages.forEach((page) => mergedPdfDoc.addPage(page));
    
        const mergedPdfBytes = await mergedPdfDoc.save();
        return new Blob([mergedPdfBytes], { type: 'application/pdf' });
      };
    
   

    const base64ToBlobs = (base64, type = 'application/pdf') => {
        const binary = atob(base64);
        const array = [];
        for (let i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], { type });
      };

   

    const [pdfData, setPdfData] = useState({});

    const handleselect = async (newblob) => {
        if (pdfData[selectedName]) {
           
            // If PDF data for this name already exists in the state
            const existingBlobString = pdfData[selectedName];
            const existingBlob = base64ToBlobs(existingBlobString);
            console.log("This is the original blob", existingBlob);

            // Combine the new blob with the existing one
            const mergedPdfBlob = await mergePdfs(existingBlob, newblob);
            console.log("This is the merged PDF Blob", mergedPdfBlob);


            // setnewblob(mergedPdfBlob);
            

            const pdfUr = window.URL.createObjectURL(mergedPdfBlob);
          
           
            setnewpdf(pdfUr);
            setnames(selectedName);
            // Convert the merged Blob to base64 and update the state
            blobToBase64(mergedPdfBlob, (base64String) => {
                setPdfData(prevPdfData => ({
                    ...prevPdfData,
                    [selectedName]: base64String  // Update state with merged PDF base64
                }));
                console.log("Stored base64 string in state:", base64String);
                // setnewpdf(null);
                setPageNumbers(1);
                // setSelectedName(newFileName);
                //  setnewSelectedName(selectedName);
                
                // alert(`Saved to "${selectedName}".`);
            });

         
        } else {
          
             setnames(selectedName);
            // If no existing PDF data, store the new blob's base64
            blobToBase64(newblob, (base64String) => {
                setPdfData(prevPdfData => ({
                    ...prevPdfData,
                    [selectedName]: base64String  // Store new PDF base64 in state
                }));
                console.log("Stored base64 string in state:", base64String);
                // setnewpdf(null);
                // setPageNumbers('');
                // setSelectedName('');
                // setSelectedName(newFileName);
                // setnewSelectedName(selectedName);
                // alert(`Saved to "${selectedName}".`);
            });
        }
    };

   
   

    const removePagesFromPdf = async () => {
        if (!file) {
            alert("Please upload a PDF file.");
            return;
        }
    
        const reader = new FileReader();
    
        reader.onload = async (event) => {
            const existingPdfBytes = event.target.result;
    
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const totalPages = pdfDoc.getPageCount();
    
            // Convert page numbers input into an array
            const pagesToRemove = Array.isArray(pageNumbers) 
                ? pageNumbers 
                : [parseInt(pageNumbers) - 1]; // Convert to zero-indexed array
    
            // Create a new PDF without the pages to remove
            const newPdfDoc = await PDFDocument.create();
            let hasValidPages = false; // Flag to track if any pages were added
    
            for (let i = 0; i < totalPages; i++) {
                if (!pagesToRemove.includes(i)) {
                    const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
                    newPdfDoc.addPage(page);
                    hasValidPages = true; // Mark that we have valid pages
                }
            }
    
            // If no valid pages remain, clear the PDF URL
            if (!hasValidPages) {

                setPdfUrl(null);
                pdfBlob=null;
                setdisable(true);
                
                // Clear the PDF URL to show the message
                return; // Exit the function
            }
    
            const newPdfBytes = await newPdfDoc.save();
            const blob = new Blob([newPdfBytes], { type: "application/pdf" });
            setFile(blob);
            const pdfUrl = URL.createObjectURL(blob);
            setPdfUrl(pdfUrl);
        };
    
        reader.readAsArrayBuffer(file);
    };
    
    
    const blobToBase64 = (blob, callback) => {
        const reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result.split(',')[1]); // Get base64 without the data URL prefix
        };
        reader.readAsDataURL(blob); // Converts the Blob to a base64 encoded string
      };
      

    //   useEffect(() => {
    //     if (pdfData[newselectedName]) {
    //         // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
    //         setnames(newselectedName);
    
    //         const existingBlobString = pdfData[newselectedName];
    //         const existingBlob = base64ToBlobs(existingBlobString);
    
    //         if (existingBlob) {
    //             const pdfUrl = window.URL.createObjectURL(existingBlob);
    //             setnewpdf(pdfUrl);
    
    //             // Clean up the object URL on component unmount
    //             return () => window.URL.revokeObjectURL(pdfUrl);
    //         } else {
    //             console.error("Blob conversion failed for", newselectedName);
               
    //         }
    //     }
    // }, [pdfData, newselectedName]);
    
    // const checkdata=()=>{
    //     if (pdfData[newselectedName]) {
    //         // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
    //         setnames(newselectedName);
    
    //         const existingBlobString = pdfData[newselectedName];
    //         const existingBlob = base64ToBlobs(existingBlobString);
    
    //         if (existingBlob) {
    //             const pdfUrl = window.URL.createObjectURL(existingBlob);
    //             setnewpdf(pdfUrl);
    
    //             // Clean up the object URL on component unmount
    //             return () => window.URL.revokeObjectURL(pdfUrl);
    //         } else {
    //             console.error("Blob conversion failed for", newselectedName);
               
    //         }
    //     }else{
    //         setnames(`No pages add in ${newselectedName}`)
    //         setnewpdf(null);
    //     }
    // }

    const checkdata = (name) => {
        if (pdfData[name]) {
            // Assuming mergedPdfBlob is passed from somewhere, make sure it is defined
            setnames(name);
    
            const existingBlobString = pdfData[name];
            const existingBlob = base64ToBlobs(existingBlobString);
    
            if (existingBlob) {
                const pdfUrl = window.URL.createObjectURL(existingBlob);
                setnewpdf(pdfUrl);
    
                // Clean up the object URL on component unmount
                return () => window.URL.revokeObjectURL(pdfUrl);
            } else {
                console.error("Blob conversion failed for", name);
            }
        } else {
            setnames(`No pages added in ${name}`);
            setnewpdf(null);
        }
    };
    
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);
    
        if (selectedFile && selectedFile.type === 'application/pdf') {
            const fileUrl = URL.createObjectURL(selectedFile);
            setPdfUrl(fileUrl);
        } else {
            setPdfUrl(null);
        }
        
    };

    
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (isSubmitting) return;  // Prevent double submission
    
        if (!file || !pageNumbers) {
            alert('Please upload a file');
            // alert('Please upload a file and specify the pages');
            return;
        }
    
        setIsSubmitting(true);  // Disable submit button
    
        const formData = new FormData();
        formData.append('file', file);
        formData.append('newFileName', newFileName);
        formData.append('pageNumbers', pageNumbers);
    
        try {
            // const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
            //     headers: {
            //         'Content-Type': 'multipart/form-data',
            //     },
            //     responseType: 'blob', // Expecting file as a response (PDF)
            // });
    
            // pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            pdfBlob=await extractPagesFromPdf();
            setnewblob(pdfBlob);
            
            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            setnewpdf(pdfUrl);
            removePagesFromPdf();
            await handleselect(pdfBlob);
            
        } catch (error) {
           alert(error);
            //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
        } finally {
            setIsSubmitting(false);  // Re-enable submit button
        }
    };
    
    
    const extractPagesFromPdf = async () => {
        if (!file) {
            alert("Please upload a PDF file.");
            return null; // Return null if no file is uploaded
        }
    
        const reader = new FileReader();
    
        return new Promise((resolve, reject) => {
            reader.onload = async (event) => {
                try {
                    const existingPdfBytes = event.target.result;
    
                    // Load the existing PDF document
                    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    
                    // Get the total number of pages in the PDF
                    const totalPages = pdfDoc.getPageCount();
    
                    // Convert page numbers input into an array
                    const pagesToExtract = Array.isArray(pageNumbers) 
                    ? pageNumbers 
                    : [parseInt(pageNumbers) - 1];
    
                    // Create a new PDF document
                    const newPdfDoc = await PDFDocument.create();
    
                    // Loop through the pages and add the specific pages to the new PDF
                    for (let i of pagesToExtract) {
                        if (i >= 0 && i < totalPages) {
                            const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
                            newPdfDoc.addPage(page);
                        }
                    }
    
                    // Save the new PDF and convert it to bytes
                    const newPdfBytes = await newPdfDoc.save();
    
                    // Create a Blob for the extracted file
                    const blob = new Blob([newPdfBytes], { type: "application/pdf" });
                    
                    // Resolve the promise with the blob
                    resolve(blob);
                } catch (error) {
                    reject(error); // Reject the promise if an error occurs
                }
            };
    
            reader.readAsArrayBuffer(file);
        });
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    
    //     if (isSubmitting) return;  // Prevent double submission
    
    //     if (!file || !pageNumbers) {
    //         alert('Please upload a file');
    //         // alert('Please upload a file and specify the pages');
    //         return;
    //     }
    
    //     setIsSubmitting(true);  // Disable submit button
    
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     formData.append('newFileName', newFileName);
    //     formData.append('pageNumbers', pageNumbers);
    
    //     try {
    //         const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
    //             headers: {
    //                 'Content-Type': 'multipart/form-data',
    //             },
    //             responseType: 'blob', // Expecting file as a response (PDF)
    //         });
    
    //         pdfBlob = new Blob([response.data], { type: 'application/pdf' });
    //         setnewblob(pdfBlob);
    
    //         const pdfUrl = window.URL.createObjectURL(pdfBlob);
    //         setnewpdf(pdfUrl);
    //         removePagesFromPdf();
    //         await handleselect(pdfBlob);
            
    //     } catch (error) {
    //        alert(error);
    //         //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
    //     } finally {
    //         setIsSubmitting(false);  // Re-enable submit button
    //     }
    // };

    const getPdfPageCount = async (base64String) => {
        const pdfData = atob(base64String); // Decode base64 to binary string
        const uint8Array = new Uint8Array([...pdfData].map(char => char.charCodeAt(0)));
    
        const pdfDocument = await pdfjsLib.getDocument(uint8Array).promise;
        return pdfDocument.numPages;
    };

    useEffect(() => {
        // Function to load PDF keys and page count
        const loadPdfInfo = async () => {
            const info = await Promise.all(Object.keys(pdfData).map(async (key) => {
                const base64 = pdfData[key];
                const numPages = await getPdfPageCount(base64);
                return { name: key, pages: numPages };
            }));
            setPdfInfo(info);
        };

        if (pdfData) {
            loadPdfInfo();
        }
    }, [pdfData]);

    const handleClick = (name) => {
        setnewSelectedName(name); // Set the selected PDF name
        checkdata(name);
        setSelectedName(name); // Call checkdata with the selected name
    };

    const iframeRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(1);

   
      
        // useEffect(() => {
        //   const iframe = iframeRef.current;
          
        //   // Check if the iframe has loaded
        //   const onIframeLoad = () => {
        //     const iframeWindow = iframe.contentWindow;
            
        //     // Track scroll within the iframe
        //     const onScroll = () => {
        //       const scrollY = iframeWindow.scrollY;
        //       setScrollPosition(scrollY);
        //       console.log("Scroll Position:", scrollY);
      
        //       // Optionally, calculate the current page based on scrollY and height
        //       // This requires knowing the total height of the PDF and height per page.
        //     };
      
        //     // Add scroll event listener to the iframe's content window
        //     iframeWindow.addEventListener('scroll', onScroll);
      
        //     return () => {
        //       iframeWindow.removeEventListener('scroll', onScroll);
        //     };
        //   };
      
        //   iframe.addEventListener('load', onIframeLoad);
      
        //   console.log("page number",scrollPosition);
        //   // Cleanup event listeners on unmount
        //   return () => {
        //     iframe.removeEventListener('load', onIframeLoad);
        //   };
        // }, []);

        // const extractLastPageFromPdf = async () => {
        //     if (pdfData[newselectedName]) {
        //         // alert("Please upload a PDF file.");
        //         // return null; // Return null if no file is uploaded

        //         const existingselectedstring = pdfData[newselectedName];
        //         const existingBlob = base64ToBlobs(existingselectedstring);
        //         console.log("this is the blob",existingBlob);
            
        //     const reader = new FileReader();
        
        //     return new Promise((resolve, reject) => {
        //         reader.onload = async (event) => {
        //             try {
        //                 console.log("existing blob",existingBlob)
        //                 const existingPdfBytes = existingBlob;
        
        //                 // Load the existing PDF document
        //                 const pdfDoc = await PDFDocument.load(existingBlob);
        
        //                 // Get the total number of pages in the PDF
        //                 const totalPages = pdfDoc.getPageCount();
        
        //                 // The index of the last page (zero-based)
        //                 const lastPageIndex = totalPages - 1;
        
        //                 // Create a new PDF document
        //                 const newPdfDoc = await PDFDocument.create();
        
        //                 // Extract the last page and add it to the new PDF
        //                 const [lastPage] = await newPdfDoc.copyPages(pdfDoc, [lastPageIndex]);
        //                 newPdfDoc.addPage(lastPage);
        
        //                 // Save the new PDF and convert it to bytes
        //                 const newPdfBytes = await newPdfDoc.save();
        
        //                 // Create a Blob for the extracted file
        //                 const blob = new Blob([newPdfBytes], { type: "application/pdf" });
        //                 console.log(" blob",blob)
        //                 // Resolve the promise with the blob
        //                 resolve(blob);
        //             } catch (error) {
        //                 reject(error); // Reject the promise if an error occurs
        //             }
        //         };
        
        //         reader.readAsArrayBuffer(file);
        //     });
        // }
        
        // };

        const extractLastPageFromPdf = async () => {
            if (pdfData[newselectedName]) {
                const existingselectedstring = pdfData[newselectedName];
                const existingBlob = base64ToBlobs(existingselectedstring); // Ensure this function works correctly
                console.log("This is the blob", existingBlob);
        
                const reader = new FileReader();
        
                return new Promise((resolve, reject) => {
                    reader.onload = async (event) => {
                        try {
                            console.log("Existing blob", existingBlob);
                            const existingPdfBytes = await reader.result; // Get the ArrayBuffer from the FileReader
        
                            // Load the existing PDF document
                            const pdfDoc = await PDFDocument.load(existingPdfBytes);
        
                            // Get the total number of pages in the PDF
                            const totalPages = pdfDoc.getPageCount();
        
                            // The index of the last page (zero-based)
                            const lastPageIndex = totalPages - 1;
        
                            // Create a new PDF document
                            const newPdfDoc = await PDFDocument.create();
        
                            // Extract the last page and add it to the new PDF
                            const [lastPage] = await newPdfDoc.copyPages(pdfDoc, [lastPageIndex]);
                            newPdfDoc.addPage(lastPage);
        
                            // Save the new PDF and convert it to bytes
                            const newPdfBytes = await newPdfDoc.save();
        
                            // Create a Blob for the extracted file
                            const blob = new Blob([newPdfBytes], { type: "application/pdf" });
                            console.log("Blob", blob);
                            // Resolve the promise with the blob
                            resolve(blob);
                        } catch (error) {
                            console.error("Error extracting the last page:", error); // Log the error
                            reject(error); // Reject the promise if an error occurs
                        }
                    };
        
                    // Read the existingBlob as an ArrayBuffer
                    reader.readAsArrayBuffer(existingBlob);
                });
            }
        };
        

        const mergePdfsreverse = async (existingBlob, newBlob) => {
            const existingPdfBytes = await file.arrayBuffer();
            const newPdfBytes = await newBlob.arrayBuffer();
        
            const existingPdfDoc = await PDFDocument.load(existingPdfBytes);
            const newPdfDoc = await PDFDocument.load(newPdfBytes);
        
            const mergedPdfDoc = await PDFDocument.create();
        
            // Add pages from the new PDF (newBlob) first
            const newPages = await mergedPdfDoc.copyPages(newPdfDoc, newPdfDoc.getPageIndices());
            newPages.forEach((page) => mergedPdfDoc.addPage(page));
        
            // Add pages from the existing PDF (existingBlobString) after
            const existingPages = await mergedPdfDoc.copyPages(existingPdfDoc, existingPdfDoc.getPageIndices());
            existingPages.forEach((page) => mergedPdfDoc.addPage(page));
        
            const mergedPdfBytes = await mergedPdfDoc.save();
            return new Blob([mergedPdfBytes], { type: 'application/pdf' });
        };

       

        const removeLastPageFromPdf = async () => {
            if (pdfData[newselectedName]) {
                const existingselectedstring = pdfData[newselectedName];
                const existingBlob = base64ToBlobs(existingselectedstring);
            const reader = new FileReader();
            return new Promise((resolve, reject) => {
            reader.onload = async (event) => {
                try {
                const existingPdfBytes = await reader.result;
        
                const pdfDoc = await PDFDocument.load(existingPdfBytes);
                const totalPages = pdfDoc.getPageCount();
        
                // The last page to remove will have an index of totalPages - 1
                const lastPageIndex = totalPages - 1;
        
                // Create a new PDF without the last page
                const newPdfDoc = await PDFDocument.create();
                let hasValidPages = false; // Flag to track if any pages were added
        
                // Copy all pages except the last one into the new PDF
                for (let i = 0; i < totalPages; i++) {
                    if (i !== lastPageIndex) { // Skip the last page
                        const [page] = await newPdfDoc.copyPages(pdfDoc, [i]);
                        newPdfDoc.addPage(page);
                        hasValidPages = true; // Mark that we have valid pages
                    }
                }
        
                // If no valid pages remain, clear the PDF URL
                if (!hasValidPages) {
                    setnewpdf(null);
                    pdfBlob = null;
                  

                if (pdfData[newselectedName]) {
                    // Create a copy of pdfData to avoid direct state mutation
                    const updatedData = { ...pdfData };

                    // Remove the key from the copied object
                    delete updatedData[newselectedName];

                    // Update the state with the modified object
                    setPdfData(updatedData);
                }

                    // setdisable(true);
                    return; // Exit the function
                }
        
                const newPdfBytes = await newPdfDoc.save();
                const blob = new Blob([newPdfBytes], { type: "application/pdf" });
                // setnewblob(blob);
                // const pdfUrl = URL.createObjectURL(blob);
                // setnewpdf(pdfUrl);
                resolve(blob)
            } catch (error) {
                console.error("Error extracting the last page:", error); // Log the error
                reject(error); // Reject the promise if an error occurs
            }
            };
        
            reader.readAsArrayBuffer(existingBlob);
        });
        }
        };

        const handleSubmitreverse = async (e) => {
            e.preventDefault();
        
            if(!pdfData[newselectedName]){
                alert("select the category");
            }else{
            if (isSubmitting) return;  // Prevent double submission
        
            // if (!file || !pageNumbers) {
            //     alert('Please upload a file');
            //     // alert('Please upload a file and specify the pages');
            //     return;
            // }
        
            // setIsSubmitting(true);  // Disable submit button
        
            // const formData = new FormData();
            // formData.append('file', file);
            // formData.append('newFileName', newFileName);
            // formData.append('pageNumbers', pageNumbers);
        
            try {
                // const response = await axios.post('http://localhost:8081/api/pdf/download', formData, {
                //     headers: {
                //         'Content-Type': 'multipart/form-data',
                //     },
                //     responseType: 'blob', // Expecting file as a response (PDF)
                // });
        
                // pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                const myblob=await extractLastPageFromPdf();
                const myblob2=await removeLastPageFromPdf();
                await handleselectreverse(myblob2);
                const files=await mergePdfsreverse(file,myblob);
                console.log("my blob",myblob)
                 setnewblob(myblob2);
        
                const pdfUrl = window.URL.createObjectURL(myblob2);
                setnewpdf(pdfUrl);


                setFile(files);
                const pdfUrls = window.URL.createObjectURL(files);
                setPdfUrl(pdfUrls);
                // const merged=mergePdfsreverse(existingBlob,pdfBlob);
                // setFie(merged);
                // await handleselect(pdfBlob);
                
            } catch (error) {
               alert(error);
                //alert("Invalid input: Double commas (,,) are not allowed in the page numbers");
            } finally {
             setIsSubmitting(false);  // Re-enable submit button
            }
            }
        };

        const handleselectreverse = async (newblob) => {
            if (pdfData[newselectedName]) {
               
                // If PDF data for this name already exists in the state
                // const existingBlobString = pdfData[selectedName];
                // const existingBlob = base64ToBlobs(existingBlobString);
                // console.log("This is the original blob", existingBlob);
    
                // // Combine the new blob with the existing one
                // const mergedPdfBlob = await mergePdfs(existingBlob, newblob);
                // console.log("This is the merged PDF Blob", mergedPdfBlob);
    
    
                // // setnewblob(mergedPdfBlob);
                
    
                // const pdfUr = window.URL.createObjectURL(mergedPdfBlob);
              
               
                // setnewpdf(pdfUr);
                // setnames(selectedName);
                // Convert the merged Blob to base64 and update the state
                blobToBase64(newblob, (base64String) => {
                    setPdfData(prevPdfData => ({
                        ...prevPdfData,
                        [newselectedName]: base64String  // Update state with merged PDF base64
                    }));
                    console.log("Stored base64 string in state:", base64String);
                    // setnewpdf(null);
                    // setPageNumbers(1);
                    // setnewSelectedName('');
                    // alert(`Saved to "${selectedName}".`);
                });
    
             
            } else {
              
                // //  setnames(selectedName);
                // // If no existing PDF data, store the new blob's base64
                // blobToBase64(newblob, (base64String) => {
                //     setPdfData(prevPdfData => ({
                //         ...prevPdfData,
                //         [selectedName]: base64String  // Store new PDF base64 in state
                //     }));
                //     console.log("Stored base64 string in state:", base64String);
                //     // setnewpdf(null);
                //     // setPageNumbers('');
                //     setSelectedName('');
                //     // alert(`Saved to "${selectedName}".`);
                // });
            alert("select the category")
            }
        };

    return (
        <div className="h-full font-sans text-gray-900 bg-gray-300 border">
            <div className="flex justify-center w-full mx-auto  shadow-lg">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6  w-full h-screen bg-white sm:rounded-lg sm:shadow-xl">
                    
                    {/* Left Section: PDF Preview */}
                    <div className="p-5 bg-gray-50 border ">
                    <div className="mb-2 flex items-center">
                                {/* <label className="block text-sm font-medium text-gray-700">Upload PDF:</label> */}
                                <input 
                                    type="file" 
                                    accept="application/pdf" 
                                    onChange={handleFileChange} 
                                    className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                                />
                            </div>
    <div className="text-center mb-2">
        <h3 className="text-lg font-medium text-gray-700">PDF Preview</h3>
    </div>
    {pdfUrl ? (
    <iframe 
     id="pdf-iframes"
        src={`${pdfUrl}#page=1&zoom=fit`} 
        title="PDF Preview" 
        className="w-full h-[600px] border border-gray-300 shadow-md" 
           frameBorder="0"
        // style={{ width: '100%', height: '100%', border: 'none' }} 
    />
) : (
    <p className="pdfMessage text-center text-gray-500">No pdf pages.</p>
)}

</div>



                    {/* Center Section: Form Input */}
                     <div className=" bg-white ">
                        {/* <div className="text-center mb-10">
                            <h2 className="text-2xl font-semibold mb-2">Upload a PDF and Create a New PDF with Selected Pages</h2>
                            <p className="text-xs text-gray-500">File should be of format .pdf</p>
                        </div> */}
                        <div className='mt-16 space-y-7'>
                        <form onSubmit={handleSubmit} className="bg-gray-100 rounded-lg shadow-inner border p-2">
                          
                           
          <div className="mb-4">
           
                                <label className="block text-sm font-medium text-gray-700">New PDF Name:</label>
                                <input
                                required
                                    type="text"
                                      placeholder="Enter new filename"
                                    
                                    value={selectedName}
                                    onChange={(e) => setSelectedName(e.target.value)}
                                    className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                                />
                           
        </div>
                            <button 
                               disabled={disable}
                                type="submit" 
                                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                                {isSubmitting ? 'Processing...' : 'Move'}
                            </button>

                            <button 
                              onClick={handleSubmitreverse}
                                className="mt-3 w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                               Remove
                            </button>
                            {/* <button 
                                type="submit" 
                                className=" mt-5 w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                               backward
                            </button> */}
                        </form>

                        {/* <div className='bg-gray-100 rounded-lg shadow-inner border p-2'>
                        <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Category:</label>
            <select
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
        </div>
          <button 
                              onClick={handleselect}
                                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600"
                            >
                               Set Category
                            </button>
                        </div> */}
<div className=" bg-gray-100 rounded-lg shadow-inner border p-2">
<div className='items-center text-center justify-center overflow-auto'>
            {/* <h1 className="block text-sm font-medium text-gray-700">Check pdf here:</h1> */}
            </div>
 {/* <div className="flex mb-4 mt-1 space-x-2">
         
            <select
            required
                value={newselectedName}
                onChange={(e) => setnewSelectedName(e.target.value)}
                className="w-96 p-2 mt-1 block  text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
            <button 
                             onClick={checkdata}
                                className="  px-5 bg-indigo-500 text-white  rounded-lg shadow hover:bg-indigo-600"
                            >
                               Check
                            </button> 
        </div> */}
        {/* <div className="grid grid-cols-2 gap-4 border overflow-y-scroll max-h-96">
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">PDF Name</div>
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">Pages</div>
            {pdfInfo.map((pdf, index) => (
                <React.Fragment key={index}>
                    <div  onClick={() => handleClick(pdf.name)} className="cursor-pointer hover:text-blue-800 border-r border-b ">{pdf.name}</div>
                    <div className=" border-r border-b">{pdf.pages}</div>
                    
                </React.Fragment>
            ))}
        </div> */}

           <div className="grid grid-cols-2 border overflow-y-scroll max-h-96">
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">PDF Name</div>
            <div className="font-bold border-r border-b py-3 bg-white sticky top-0 z-20">Pages</div>
            {pdfInfo.map((pdf, index) => (
                <React.Fragment key={index}>
                    <div  onClick={() => handleClick(pdf.name)} className="cursor-pointer hover:text-red-700 border-r border-b py-3">{pdf.name}</div>
                    <div className=" border-r border-b py-3">{pdf.pages}</div>
                    
                </React.Fragment>
            ))}
        </div>
 
        </div>
                        

                       

                        {/* <button onClick={handleRefresh} className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg shadow hover:bg-indigo-600">
      Clear
    </button> */}
                        </div>

                    </div> 

                  
                    {/* Right Section: Extracted PDF Response */}
                    <div className="p-5 bg-gray-50 border">
                    <form onSubmit={downloadFiles}>
                             <div className="flex   space-x-2">
                                
                                <input
                                    type="text"
                                    // value={employeecode}
                                    // onChange={(e) => setemployeecode(e.target.value)}
                                    placeholder="Enter employee code"
                                    className="invisible w-96 p-1 block  text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
                                />
                           
                            {/* <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">Category:</label>
            <select
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                className="p-2 mt-1 block w-full text-sm text-gray-500 border border-gray-300 rounded-md shadow-sm"
            >
                <option value="" disabled>Select a name</option>
                {names.map((name, index) => (
                    <option key={index} value={name}>
                        {name}
                    </option>
                ))}
            </select>
        </div> */}
                           
                            <button 
                                type="submit" 
                                className="px-5 bg-black  text-white  rounded-full shadow hover:bg-slate-700 "
                            >
                                Save
                            </button>
                            </div>
                        </form>
                        <div className="text-center ">
                            <h3 className="text-lg font-medium text-gray-700">Extracted PDF</h3>
                        </div>
                      <h4>{namess}.pdf</h4>
                     
    {/* Display any extracted PDF data or response here */}
    {loading ? (
        <div className=" flex space-x-2 justify-center items-center bg-white h-screen dark:invert">
            <span className="sr-only">Loading...</span>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="h-8 w-8 bg-black rounded-full animate-bounce"></div>
        </div>
    ) : newpdf ? (
        <iframe 
        id="pdf-iframe"
        ref={iframeRef}
            src={`${newpdf}#page=1&zoom=fit`} 
            title="PDF Preview" 
            className="w-full h-[600px] border border-gray-300 shadow-md fixed sticky" 
            frameBorder="0"
            // style={{ width: '100%', height: '100%', border: 'none' }} 
        />
    ) : (
        <p className="text-center text-gray-500">No PDF uploaded yet</p>
    )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Newcheck;




